import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74f7a160"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-align-items-center is-flex is-flex-direction-row" }
const _hoisted_2 = {
  key: 0,
  class: "buttons preview-buttons"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-lg fas fa-image" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-lg fas fa-cube" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "has-text-centered has-text-weight-bold"
}

import i18n from '@/locales'
import Part3dModal from '@/components/library/content/Part3dModal.vue'
import TwoDModal from '@/components/library/content/TwoDModal.vue'
import { computed, onBeforeMount, Ref, ref } from 'vue'
import { Thumbnail } from '@/components/common'
import { getCurrentScsFile } from '@/controllers/library/part3dFile'
import { useComposableForEsc } from '@/components/common/modal/useComposableForEsc'
import { useStore } from 'vuex'
import { postError } from '@/helpers/notification'

enum PreviewType { TwoDFile, ThreeDFile }


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPreview',
  props: {
  content: {
    type: Object,
    required: true
  },
},
  setup(__props) {

const props = __props
const store = useStore()

const entityType = props.content.contentType ||
  props.content.entityType ||
  props.content.mediaType ||
  props.content.type
const filepathFor2d: Ref<string> = ref('')
const filepathFor3d = ref({
  png: '',
  scs: ''
})

const has3dFeatures: boolean = store.getters['user/has3dFeatures']
const hasPreviewButtons = ref(false)
const is2dPreviewOpen = ref(false)
const is3dPreviewOpen = ref(false)
const previewModalTitle = ref('')
const selectedPreview = ref(PreviewType.TwoDFile)

const canShowPreview = computed(() => {
  if (entityType !== 'part') return false

  switch (selectedPreview.value) {
    case PreviewType.ThreeDFile:
      return !!filepathFor3d.value.scs && has3dFeatures
    case PreviewType.TwoDFile:
      return !!filepathFor2d.value
  }
})
const onClosePreviewModal = () => {
  is2dPreviewOpen.value = false
  is3dPreviewOpen.value = false
}
const onOpenPreviewModal = () => {
  if (!canShowPreview.value) return

  switch (selectedPreview.value) {
    case PreviewType.ThreeDFile:
      if (!filepathFor3d.value.scs) return
      is2dPreviewOpen.value = false
      is3dPreviewOpen.value = true
      break
    case PreviewType.TwoDFile:
      if (!filepathFor2d.value) return
      is2dPreviewOpen.value = true
      is3dPreviewOpen.value = false
      break
  }
}

onBeforeMount(async () => {
  if (!!props.content.thumbnailUrlLarge) {
    filepathFor2d.value = `${window.location.protocol}//${window.location.host}${props.content.thumbnailUrlLarge}`
  }

  if (entityType !== 'part') return
  if (has3dFeatures) {
    try {
      const part3dFile = await getCurrentScsFile(props.content.id)

      if (!!part3dFile.scsFileUrl) {
        filepathFor3d.value.png = `${window.location.protocol}//${window.location.host}${part3dFile.pngFileUrl}`
        filepathFor3d.value.scs = `${window.location.protocol}//${window.location.host}${part3dFile.scsFileUrl}`
      }
    } catch (e) {
      console.error('3D files failed to load')
      postError({
        title: i18n.global.t('error'),
        text: i18n.global.t('failedToLoad', {
          content: i18n.global.tc('file', 2)
        }),
      })
    }

    if (!!filepathFor2d.value && !!filepathFor3d.value.scs) {
      selectedPreview.value = PreviewType.TwoDFile
    } else if (!filepathFor2d.value && !!filepathFor3d.value.scs && has3dFeatures) {
      selectedPreview.value = PreviewType.ThreeDFile
    } else {
      selectedPreview.value = PreviewType.TwoDFile
    }
  }

  if (!!props.content?.partNumber) {
    previewModalTitle.value = `${props.content.name} (${props.content.partNumber})`
  } else {
    previewModalTitle.value = `${props.content.name}`
  }

  hasPreviewButtons.value = has3dFeatures &&
    !!filepathFor2d.value &&
    !!filepathFor3d.value.scs
})

useComposableForEsc({
  dismissFunction: onClosePreviewModal,
  isActive: computed(() => is2dPreviewOpen.value || is3dPreviewOpen.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (hasPreviewButtons.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              class: _normalizeClass(["button", { 'is-primary': selectedPreview.value === PreviewType.TwoDFile }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedPreview.value = PreviewType.TwoDFile))
            }, _hoisted_4, 2),
            _createElementVNode("button", {
              class: _normalizeClass(["button", { 'is-primary': selectedPreview.value === PreviewType.ThreeDFile }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedPreview.value = PreviewType.ThreeDFile))
            }, _hoisted_6, 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({ 'cursor-pointer': canShowPreview.value }),
        onClick: onOpenPreviewModal
      }, [
        _withDirectives(_createVNode(_unref(Thumbnail), {
          class: "info-thumbnail",
          "data-int": "info-thumbnail",
          "thumbnail-type": _unref(entityType),
          "thumbnail-url": __props.content.thumbnailUrlLarge
        }, null, 8, ["thumbnail-type", "thumbnail-url"]), [
          [_vShow, selectedPreview.value === PreviewType.TwoDFile]
        ]),
        _withDirectives((_openBlock(), _createBlock(_unref(Thumbnail), {
          class: "info-thumbnail",
          "thumbnail-type": "info",
          key: filepathFor3d.value.png,
          "thumbnail-url": filepathFor3d.value.png
        }, null, 8, ["thumbnail-url"])), [
          [_vShow, selectedPreview.value === PreviewType.ThreeDFile]
        ]),
        (canShowPreview.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('clickToEnlarge')), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _withDirectives(_createVNode(TwoDModal, {
      filepath: filepathFor2d.value,
      title: previewModalTitle.value,
      onClose: onClosePreviewModal
    }, null, 8, ["filepath", "title"]), [
      [_vShow, is2dPreviewOpen.value]
    ]),
    (is3dPreviewOpen.value)
      ? (_openBlock(), _createBlock(Part3dModal, {
          filepath: filepathFor3d.value.scs,
          key: `3d-${is3dPreviewOpen.value}`,
          title: previewModalTitle.value,
          onClose: onClosePreviewModal
        }, null, 8, ["filepath", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})